<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div align="center">
      <p>确定删除订单</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDeleteShopHouseModel">点错了</el-button>
      <el-button type="primary" @click="deleteInoutOrder">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteInoutOrder } from '@/api/goods/downShopHouseApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  data() {
    return {
      dialogVisible: false,
      deleteInoutOrderInfo: {}
    }
  },
  methods: {
    open(data) {
      this.deleteInoutOrderInfo = data
      this.dialogVisible = true
    },
    handleClose(done) {
      this.closeDeleteShopHouseModel()
      done()
    },
    closeDeleteShopHouseModel() {
      this.dialogVisible = false
    },
    async deleteInoutOrder() {
      try {
        let shopId = getShopId()
        this.deleteInoutOrderInfo.shopId = shopId
        await deleteInoutOrder(this.deleteInoutOrderInfo)
        this.$emit('refresh')
        this.$message.success('删除成功')
        this.closeDeleteShopHouseModel()
      } catch (error) {
        console.error('删除失败:', error)
      }
    }
  }
}
</script>